import type { UUID } from "utils";

const BASE_URL = "/accounts";

export const PAGE_URLS = {
  payments: `${BASE_URL}/payments`,
  paymentDetails: `${BASE_URL}/payments/:id`,
  getLinkToPaymentDetails: (id: UUID) => `${BASE_URL}/payments/${id}`,
};
